import { gql } from "@apollo/client";

export const RESET_DEVICE_ID = gql`
  mutation ResetDeviceId {
    resetDeviceId {
      success
    }
  }
`;
